const standardActions = new Map().set('vaultUpload', true)

export const mimeTypes = {
  'application/pdf': {
    icon: 'mdi-file-pdf-box',
    color: 'blue',
    actions: standardActions,
    extension: 'pdf'
  },
  'application/msword': {
    icon: 'mdi-file-word',
    color: 'blue',
    actions: standardActions,
    extension: 'doc'
  },
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': {
    icon: 'mdi-file-word',
    color: 'blue',
    actions: standardActions,
    extension: 'docx'
  },
  multiple: {
    icon: 'mdi-file-document',
    color: 'grey',
    actions: null
  }
}

export const uploadMimeTypes = Object.fromEntries(
  Object.entries(mimeTypes).filter(
    ([_key, value]) => value.actions && value.actions.has('vaultUpload')
  )
)

export const uploadAcceptExtensions = Object.values(uploadMimeTypes)
  .map((value) => '.' + value.extension)
  .join(',')

export function areValidMimeTypes(files) {
  if (!files || !files.length) {
    return true
  }
  const filesMimeTypes = files.map((file) => file.type)
  return filesMimeTypes.every((fileMimeType) => fileMimeType in uploadMimeTypes)
}
